export default __webpack_public_path__ + "static/media/icon_Oasis_white.b63aaa66.svg";